import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from "shards-react";
import Firebase from 'firebase';
import { Link } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import toast, { Toaster } from 'react-hot-toast';

const notify = () => toast('Je wijzigingen zijn opgeslagen!');

class ChangeProductsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order:[]
        };
    }

    componentWillMount() {


        let ref = Firebase.database().ref('/orders/'+this.props.data.data.key);
        ref.on('value' , snapshot => {

            let state = snapshot.val();

            this.setState({
                order: state
            })

            console.log(state)


           

           
             


            
        });
   
       
    }

    

    render() {
        return (
            <div>
                <Toaster />
            <Row className="col-sm-12">
                <Col sm={12} className="products-actions">
                    <Link to={{pathname: `/producten`}}>Terug</Link>
                    {/*<Button className="main-save-button" onClick={()=>this.changeProduct()}>Opslaan</Button>
                  <Link className="align-button-right">Product toevoegen</Link>*/}
                </Col>
                <Col sm={12} className="colum-left">
                    <Row>
                        <Col sm={12} className="add-product-colum">
                            <label>Naam</label><br/>
                            <input disabled type="text"  value={this.state.order.firstname + ' ' +this.state.order.lastname }/><br/><br/>
                            <label>Adres</label><br/>
                            <input disabled type="text"  value={this.state.order.adres}/><br/><br/>
                            <label>Postcode</label><br/>
                            <input disabled type="text"  value={this.state.order.postal}/><br/><br/>
                            <label>Plaats</label><br/>
                            <input disabled type="text"  value={this.state.order.city}/><br/><br/>
                            <label>E-mail</label><br/>
                            <input disabled type="text"  value={this.state.order.mail}/><br/><br/>
                            <label>Telefoon</label><br/>
                            <input disabled type="text"  value={this.state.order.phone}/><br/><br/>
                            <label>Geboorte datum</label><br/>
                            <input disabled type="text"  value={this.state.order.birthdate}/><br/><br/>
                         
                            
                        </Col>
                        <Col sm={12} className="add-product-colum">
                        <label>School</label><br/>
                            <input disabled type="text"  value={this.state.order.school}/><br/><br/>
                            <label>Groep</label><br/>
                            <input disabled type="text"  value={this.state.order.group}/><br/><br/>
                            <label>Junioren/ Senioren</label><br/>
                            <input disabled type="text"  value={this.state.order.typeAge}/><br/><br/>
                            <label>Zwemdiploma</label><br/>
                            <input disabled type="text"  value={this.state.order.swimCertificate}/><br/><br/>
                           
                        </Col>

                        <Col sm={12} className="add-product-colum">
                        <label>Naam ziektekostenverzekering</label><br/>
                            <input disabled type="text"  value={this.state.order.nameDoctor}/><br/><br/>
                            <label>Verzekeringsnummer</label><br/>
                            <input disabled type="text"  value={this.state.order.numberInsurance}/><br/><br/>
                            <label>Huisarts + telefoonnummer</label><br/>
                            <input disabled type="text"  value={this.state.order.phoneDoctor}/><br/><br/>
                            <label>Overige bijzonderheden / medische gegevens</label><br/>
                            <CKEditor
                                editor={ ClassicEditor }
                                data={this.state.order.specialties}
                            
                                disabled

                            />
                           
                        </Col>
                        <Col sm={12} className="add-product-colum">
                        <label>Ik wil graag in de groep bij</label><br/>
                            <input disabled type="text"  value={this.state.order.choiceNameOne}/><br/><br/>
                            <label>Hij/ zij zit op de volgende school</label><br/>
                            <input disabled type="text"  value={this.state.order.choiceSchoolOne}/><br/><br/>
                            <label>Ik wil graag in de groep bij</label><br/>
                            <input disabled type="text"  value={this.state.order.choiceNameTwo}/><br/><br/>
                            <label>Hij/ zij zit op de volgende school</label><br/>
                            <input disabled type="text"  value={this.state.order.choiceSchoolTwo}/><br/><br/>
                        </Col>

                        <Col sm={12} className="add-product-colum">
                        <label>Ik mag wel/ niet alleen naar huis als KVW is afgelopen</label><br/>
                            <input disabled type="text"  value={this.state.order.aloneToHome}/><br/><br/>
                            <label>Ik wordt opgehaald door</label><br/>
                            <input disabled type="text"  value={this.state.order.pickedUpBy}/><br/><br/>
                        </Col>

                        <Col sm={12} className="add-product-colum">
                        <label>Ik ga akkoord met de algemenevoorwaarden</label><br/>
                            <input disabled type="text"  value={this.state.order.terms}/><br/><br/>
                            
                        </Col>
                       

                    </Row>
                </Col>
            
                {/*<Col sm={4}>
                    <Row>
                        <Col sm={12} className="add-product-colum right-product-add-colom">
                            <label>Productstatus</label><br/>
                            <select value={this.state.status} onChange={(event)=>this.setState({status: event.target.value,changes:true})}>
                            <option value="selected" selected="selected" disabled="disabled">Selecteer een status</option>
                                <option value="concept">Concept</option>
                                <option value="active">Actief</option>
                            </select>
                            
                        </Col>
                        <Col sm={12} className="add-product-colum right-product-add-colom categories-products">
                            <label>Categorieën</label><br/>
                            <select value={this.state.cat} onChange={(event)=> this.addCat( event.target.value)}>
                            <option value="selected" selected="selected" disabled="disabled">Selecteer een categorie</option>
                                <option value="Kleding, Schoenen & Lederwaren">Kleding, Schoenen & Lederwaren</option>
                                <option value="Internet, Tv & Bellen">Internet, Tv & Bellen</option>
                                <option value="Wonen & Inrichten">Wonen & Inrichten</option>
                                <option value="Auto's, Brommers & Fietsen">Auto's, Brommers & Fietsen</option>
                                <option value="Flora & Fauna">Flora & Fauna</option>
                                <option value="Uiterlijke Verzorging">Uiterlijke Verzorging</option>
                                <option value="Zorg & Welzijn">Zorg & Welzijn</option>
                                <option value="Sieraden & Accessoires">Sieraden & Accessoires</option>
                                <option value="Sport, Muziek & Vrije tijd">Sport, Muziek & Vrije tijd</option>
                                <option value="Eten & Drinken">Eten & Drinken</option>
                                <option value="Warenhuis & Speelgoed">Warenhuis & Speelgoed</option>
                            </select>
                            <br/>
                        
                            <br/>

                            <label>Geselecteerde categorieën</label><br/>
                            {this.state.catActive?
                            <ul className="button-list">
                                {this.state.categories.map((item)=>(
                                    <li>{item.name}  <Button   onClick={()=>this.deleteCat(item.id)}>Verwijder</Button></li>
                                ))}
                               
                                
                            </ul>
                            :<span>Geen categorien geselecteerd</span>}
                            
                        </Col>
                       {/* <Col sm={12} className="add-product-colum right-product-add-colom categories-products">
                            <label>Tags</label><br/>
                            
                            <select value={this.state.tag} onChange={(event)=>this.setState({tag: event.target.value})}>
                            <option value="selected" selected="selected" disabled="disabled">Selecteer een tag</option>
                                <option value="Eten en drinken">Eten & Drinken</option>
                                <option value="Sieraden">Sieraden</option>
                                <option value="Kleding">Kleding</option>
                            </select><br/>
                            <Button onClick={()=>this.addTag()}>Maak tags aan</Button><br/><br/>
                            <br/>

                            <label>Geselecteerde tags</label><br/>
                            {this.state.tagActive?
                            <ul className="button-list" >
                                {this.state.tags.map((item)=>(
                                    <li>{item.name}  <Button  onClick={()=>this.deleteTag(item.id)}>Verwijder</Button></li>
                                ))}
                               
                                
                            </ul>
                            :<span>Geen tags geselecteert</span>}
                            
                                </Col>
                    </Row>
                </Col>*/}
   
            </Row>
            {this.state.changes?
            <Row className="changed-row">
                <Col sm={12} className="changed-col">
                    <p>Er zijn wijzigingen aangebracht. Vergeet niet om het product op te slaan.</p>
                    <Button  className="changed-button" onClick={()=>this.changeProduct()}>Opslaan</Button>
                </Col>
            </Row>:null}
            </div>



        );
    }
};

export default ChangeProductsComponent;